import { supabase } from '../supabase';

export type CiudadListaItem = {
  id: number;
  nombre: string;
  latitud_centro: number | null;
  longitud_centro: number | null;
};

export async function fetchCiudadesLista(): Promise<CiudadListaItem[]> {
  const { data, error } = await supabase
    .from('ciudades')
    .select('id, nombre, latitud_centro, longitud_centro')
    .order('nombre', { ascending: true });

  if (error) throw error;
  return (data ?? []).map((row: any) => ({
    id: row.id,
    nombre: row.nombre,
    latitud_centro: row.latitud_centro ?? null,
    longitud_centro: row.longitud_centro ?? null,
  }));
}

/**
 * Asigna una sola ciudad al usuario (reemplaza relaciones previas). Para comensales, sin tocar admin_id de ciudades.
 */
export async function setComensalCiudadPreferida(usuarioId: string, ciudadId: number): Promise<void> {
  const { error: deleteError } = await supabase.from('usuarios_ciudades').delete().eq('usuario_id', usuarioId);
  if (deleteError) throw deleteError;

  const { error: insertError } = await supabase.from('usuarios_ciudades').insert({
    usuario_id: usuarioId,
    ciudad_id: ciudadId,
  });
  if (insertError) throw insertError;
}

/** Quita todas las ciudades asociadas (p. ej. comensal eligió «Otra»). */
export async function clearComensalCiudades(usuarioId: string): Promise<void> {
  const { error } = await supabase.from('usuarios_ciudades').delete().eq('usuario_id', usuarioId);
  if (error) throw error;
}
